<template>
    <BaseModal id="delivery-form">
        <template #default="{close}">
            <MoneyDeliveryForm  @close="close"/>
        </template>
    </BaseModal>
    </template>
    
    <script>
    import BaseModal from "@/components/utils/BaseModal.vue";
    import MoneyDeliveryForm from "@/components/Forms/MoneyDeliveryForm.vue";
    
    export default {
        name: "PopupMoneyDelivery",
        components: {BaseModal, MoneyDeliveryForm},
    }
    </script>